import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  FormControl,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core'
import { Cancel, Delete, Edit, Save } from '@material-ui/icons'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  itemWrapper: {
    '@media (max-width: 768px)': {
      flexBasis: '100%',
      maxWidth: '100%',
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
      boxSizing: 'border-box',
    },
  },
  card: {
    textAlign: 'center',
    background: 'linear-gradient(160deg, rgba(86,86,92,0.9) 0%, rgba(42,42,48,0.98) 100%)',
    color: 'white',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 18,
    border: '1px solid rgba(255,255,255,0.1)',
    boxShadow: '0 16px 30px rgba(0,0,0,0.35)',
    '@media (max-width: 768px)': {
      width: '100%',
      maxWidth: 'none',
      marginLeft: 0,
      marginRight: 0,
      boxSizing: 'border-box',
    },
  },
  headerPanel: {
    background: 'rgba(255,255,255,0.06)',
    borderRadius: 14,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: 12,
  },
  headerText: {
    fontWeight: 700,
    letterSpacing: 0.4,
  },
  statusBadge: {
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  statusFound: { color: '#55d685' },
  statusMaybe: { color: '#f5d76e' },
  statusNotFound: { color: '#ff6b6b' },

  details: {
    width: '100%',
    textAlign: 'left',
    paddingTop: 8,
    paddingBottom: 4,
  },
  detailsLabel: {
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: 'rgba(245,241,255,0.72)',
    marginBottom: 8,
  },
  commentText: {
    whiteSpace: 'pre-line',
    wordBreak: 'break-word',
    lineHeight: 1.45,
    color: 'rgba(245,241,255,0.92)',
  },
  link: {
    color: '#8ad3ff',
    fontWeight: 600,
    textDecoration: 'none',
  },

  // centered image wrapper
  mediaWrap: {
    width: '92%',
    margin: '12px auto 0',
    borderRadius: 14,
    border: '1px solid rgba(255,255,255,0.15)',
    boxShadow: '0 10px 22px rgba(0,0,0,0.25)',
    overflow: 'hidden',
    background: 'rgba(12,12,16,0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 260,
  },
  media: {
    width: '100%',
    height: '100%',
    maxHeight: 420,
    objectFit: 'contain',
    display: 'block',
  },

  formControl: {
    width: '100%',
    marginBottom: 12,
    '& .MuiOutlinedInput-root': {
      background: 'linear-gradient(180deg, rgba(36,36,44,0.92) 0%, rgba(18,18,24,0.96) 100%)',
      borderRadius: 16,
      color: 'white',
      boxShadow: '0 12px 22px rgba(0,0,0,0.38)',
      transition: 'box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(176,155,255,0.6)',
        borderWidth: 1.5,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(201,182,255,0.95)',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d2b9ff',
      },
      '&.Mui-focused': {
        background: 'linear-gradient(180deg, rgba(44,44,52,0.96) 0%, rgba(20,20,26,0.98) 100%)',
        boxShadow: '0 14px 26px rgba(0,0,0,0.5)',
      },
    },
    '& .MuiSelect-icon': {
      color: 'rgba(236,232,255,0.85)',
    },
  },
  selectLabel: {
    color: 'rgba(236,232,255,0.85)',
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    textShadow: '0 1px 6px rgba(140,120,220,0.35)',
    '&.Mui-focused': {
      color: '#e4d6ff',
    },
  },
  selectField: {
    borderRadius: 12,
    color: 'white',
  },
  commentField: {
    background: 'rgba(12,12,16,0.55)',
    borderRadius: 12,
  },
  commentInput: {
    color: 'white',
  },
  actions: {
    padding: '8px 16px 16px',
  },
})

function linkify(text, classes) {
  if (!text) return null

  const urlRegex = /(https?:\/\/[^\s]+)/g
  const parts = String(text).split(urlRegex)

  return parts.map((part, idx) => {
    const isUrl = part && /^https?:\/\//i.test(part)
    if (!isUrl) return <React.Fragment key={idx}>{part}</React.Fragment>

    return (
      <React.Fragment key={idx}>
        <Link
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
        >
          {part}
        </Link>
      </React.Fragment>
    )
  })
}

class VisualItems extends Component {
  state = {
    editVisual: false,
    userEdits: {
      newVisualComment: '',
      newMatchLevel: '',
      newVisualId: 0,
    },
  }

  openEdit = () => {
    const { visual } = this.props
    this.setState({
      editVisual: true,
      userEdits: {
        newVisualComment: visual.comment || '',
        newMatchLevel: visual.match_level || 'Not Found',
        newVisualId: visual.id,
      },
    })
  }

  closeEdit = () => {
    this.setState({ editVisual: false })
  }

  handleVisualSave = () => {
    this.props.dispatch({
      type: 'UPDATE_VISUAL',
      payload: this.state.userEdits,
    })
    this.setState({ editVisual: false })
  }

  // safe: capture value first
  handleChangeFor = (propertyName) => (event) => {
    const value = event?.target?.value ?? ''
    this.setState(prev => ({
      userEdits: {
        ...prev.userEdits,
        [propertyName]: value,
      },
    }))
  }

  handleDeleteVisual = (id) => {
    this.props.dispatch({
      type: 'DELETE_VISUAL',
      payload: id,
    })
  }

  render() {
    const { classes, visual, user } = this.props
    const clearanceId = Number(user?.clearance_id)
    const canCommentEdit = Number.isFinite(clearanceId) ? clearanceId >= 1 : Boolean(user?.id)
    const canStatusEdit = Number.isFinite(clearanceId) && clearanceId > 1

    const matchLevel = visual.match_level || 'Not Found'
    const statusLabel = matchLevel === 'Maybe Found' ? 'Maybe' : matchLevel
    const statusClass =
      matchLevel === 'Found'
        ? classes.statusFound
        : matchLevel === 'Maybe Found'
          ? classes.statusMaybe
          : classes.statusNotFound

    return (
      <Grid item sm={4} align="center" className={classes.itemWrapper}>
        <Card className={classes.card}>
          <CardContent>
            <CardActionArea>
              <ExpansionPanel className={classes.headerPanel}>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon color="secondary" />}
                  aria-controls={`visual-${visual.id}-content`}
                  id={`visual-${visual.id}-header`}
                >
                  <div className={classes.headerRow}>
                    <Typography color="secondary" className={classes.headerText}>
                      Visual #{visual.image_number}
                    </Typography>

                    <Typography className={`${classes.statusBadge} ${statusClass}`}>
                      {statusLabel}
                    </Typography>
                  </div>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails className={classes.details}>
                  <div style={{ width: '100%' }}>
                    <Typography className={classes.detailsLabel}>Comment</Typography>

                    <Typography variant="body1" className={classes.commentText}>
                      {linkify(visual.comment, classes) || (
                        <span style={{ color: 'rgba(245,241,255,0.6)' }}>
                          No comment yet.
                        </span>
                      )}
                    </Typography>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </CardActionArea>
          </CardContent>

          <a href={visual.url} target="_blank" rel="noopener noreferrer">
            <div className={classes.mediaWrap}>
              <CardMedia
                component="img"
                alt={visual.comment || `Visual #${visual.image_number}`}
                className={classes.media}
                image={visual.url}
                title={visual.comment || `Visual #${visual.image_number}`}
              />
            </div>
          </a>

          <CardContent>
            {this.state.editVisual && canStatusEdit && (
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id={`match-level-${visual.id}`} className={classes.selectLabel}>
                  Match
                </InputLabel>

                <Select
                  labelId={`match-level-${visual.id}`}
                  value={this.state.userEdits.newMatchLevel}
                  onChange={this.handleChangeFor('newMatchLevel')}
                  label="Match"
                  className={classes.selectField}
                >
                  <MenuItem value="Found">Found</MenuItem>
                  <MenuItem value="Maybe Found">Maybe Found</MenuItem>
                  <MenuItem value="Not Found">Not Found</MenuItem>
                </Select>
              </FormControl>
            )}

            {this.state.editVisual && (
              <TextField
                variant="outlined"
                multiline
                minRows={3}
                placeholder="Enter any ideas or sources"
                value={this.state.userEdits.newVisualComment}
                onChange={this.handleChangeFor('newVisualComment')}
                className={classes.commentField}
                fullWidth
                InputProps={{
                  className: classes.commentInput,
                }}
              />
            )}
          </CardContent>

          <CardActions className={classes.actions} style={{ justifyContent: "flex-start" }}>
            {!this.state.editVisual && canCommentEdit && (
              <Button
                color="secondary"
                variant="outlined"
                onClick={this.openEdit}
                style={{ marginRight: 20, marginLeft: 0 }}
              >
                <Edit style={{ marginRight: 3 }} />
                Edit
              </Button>
            )}

            {!this.state.editVisual && canStatusEdit && (
              <Button
                onClick={() => this.handleDeleteVisual(visual.id)}
                style={{ marginLeft: 'auto', marginRight: 0, color: user.color }}
              >
                <Delete style={{ marginRight: 3 }} />
                Delete
              </Button>
            )}

            {this.state.editVisual && (
              <Button color="secondary" variant="outlined" onClick={this.closeEdit} style={{ marginRight: 20, marginLeft: 0 }}>
                <Cancel style={{ marginRight: 3 }} />
                Cancel
              </Button>
            )}

            {this.state.editVisual && (
              <Button
                onClick={this.handleVisualSave}
                style={{ marginLeft: 'auto', marginRight: 0, color: user.color }}
              >
                <Save style={{ marginRight: 3 }} />
                Save
              </Button>
            )}
          </CardActions>
        </Card>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
})

export default withRouter(connect(mapStateToProps)(withStyles(styles)(VisualItems)))
